import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useLanguageAttribute = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const htmlElement = document.getElementById('html-root');
    if (htmlElement) {
      htmlElement.setAttribute('lang', i18n.language);
    }
  }, [i18n.language]);
};
